import { render, staticRenderFns } from "./WechatCommitExchange.vue?vue&type=template&id=34ed27d0&scoped=true"
import script from "./WechatCommitExchange.vue?vue&type=script&lang=js"
export * from "./WechatCommitExchange.vue?vue&type=script&lang=js"
import style0 from "./WechatCommitExchange.vue?vue&type=style&index=0&id=34ed27d0&prod&lang=stylus&scoped=scoped"
import style1 from "./WechatCommitExchange.vue?vue&type=style&index=1&id=34ed27d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed27d0",
  null
  
)

export default component.exports